import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { createTheme, ThemeProvider, CssBaseline } from '@mui/material';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Quality from './pages/Quality'; // New page
import Contact from './pages/Contact';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

// Custom theme with typography settings
const theme = createTheme({
  palette: {
    primary: {
      main: '#0d47a1', // Deep Blue for Industrial look
    },
    secondary: {
      main: '#546e7a', // Blue Grey
    },
    background: {
      default: '#f4f6f8',
    },
  },
  typography: {
    fontFamily: '"Lato", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 600,
    },
    h3: {
      fontWeight: 600,
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <ScrollToTop />
        <Header />
        <main style={{ minHeight: '80vh', paddingTop: '64px' }}> {/* Add padding for fixed header */}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} /> {/* Manufacturing & Industries will live here */}
            <Route path="/quality" element={<Quality />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </Router>
    </ThemeProvider>
  );
}

export default App;
